import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaCircleXmark } from 'react-icons/fa6';
import styles from './styles.module.css';

interface ErrorScreenProps {
    status?: number | string;
}

const ErrorScreen = ({ status }: ErrorScreenProps) => {
    const { t } = useTranslation('components');
    const [isOnline, setIsOnline] = useState<boolean>(navigator.onLine);

    useEffect(() => {
        const handleOnline = () => setIsOnline(true);
        const handleOffline = () => setIsOnline(false);

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);
        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

    const handleRefresh = () => {
        window.location.reload();
    };

    // Determine which message key to use
    let messageKey = 'errors.global.msg';
    let buttonKey = 'errors.global.btn';

    if (!isOnline) {
        messageKey = 'errors.no_internet.msg';
        buttonKey = 'errors.no_internet.btn';
    } else {
        switch (status) {
            case 403:
                messageKey = 'errors.unauthorized.msg';
                buttonKey = 'errors.unauthorized.btn';
                break;
            case 404:
                messageKey = 'errors.not_found.msg';
                buttonKey = 'errors.not_found.btn';
                break;
            case 500:
                messageKey = 'errors.server.msg';
                buttonKey = 'errors.server.btn';
                break;
            default:
                messageKey = 'errors.global.msg';
                buttonKey = 'errors.global.btn';
                break;
        }
    }

    return (
        <div className={styles.wrapper}>
            <div className="text-center">
                <div className={styles.iconCon}>
                    <FaCircleXmark size={90} />
                </div>

                <div>
                    <p className={styles.content}>{t(messageKey)}</p>

                    <div className={styles.btn__con}>
                        <button onClick={handleRefresh} type="button" className={styles.bttn__primary}>
                            {t(buttonKey)}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ErrorScreen;
